import { render } from "./Alman.vue?vue&type=template&id=365443e2"
import script from "./Alman.vue?vue&type=script&lang=js"
export * from "./Alman.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__